import React from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import {portfoliosActions, uiActions, appSelectors} from '@/store'
import type {Language} from '@/types'
import UploadFileForm from '@/views/forms/upload-file'

type Props = {
  setupUploadFileForm: (string) => void,
  l: Language,
  id?: string,
}

export const RawUploadFileButton = (props: Props) =>
  <button
    id={props.id}
    className="btn btn-warning"
    onClick={() => {
      if (props.type === 'import' || props.type === 'sync') {
        props.showInfoModal(UploadFileForm, {
          title: props.title,
          onConfirm: props.onConfirm,
          type: props.type,
        })
      } else {
        props.setupUploadFileForm(props.type)
        props.showEditModal({
          title: props.title,
          onConfirm: props.onConfirm,
          type: props.type,
        })
      }
    }}
  >
    {props.l(props.title)}
  </button>

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, uiActions]),
)(RawUploadFileButton)



// WEBPACK FOOTER //
// ./src/views/portfolios-page/upload-file-button.js